import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=940ed37e&scoped=true&"
import script from "./PromoCodes.vue?vue&type=script&lang=js&"
export * from "./PromoCodes.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodes.vue?vue&type=style&index=0&id=940ed37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940ed37e",
  null
  
)

export default component.exports